import { createSlice } from '@reduxjs/toolkit';
import 'api/authAPI';
import { baseAPI } from 'api/base';
import { loadState, saveState, removeState } from 'utils';
// ,
const STORAGE_KEY = 'cayesh_user_loggged';
const storedUser = loadState(STORAGE_KEY);

const initialState = {
	token: storedUser?.token ?? null,
	isAuthenticated: storedUser?.token ? true : false,
	verified: storedUser?.verified ? true : false,
	user: storedUser?.user || {},
	currentCompany: storedUser?.currentCompany || {},
	companies: storedUser?.companies || [],
	permissions: storedUser?.permissions || {}
};

const slice = createSlice({
	name: 'auth',
	initialState: initialState,
	reducers: {
		logoutReducer: state => {
			removeState(STORAGE_KEY);
			state.isAuthenticated = false;
			state.verified = false;
			state.token = null;
		}
	},
	extraReducers: builder => {
		builder
			.addMatcher(baseAPI.endpoints.login.matchFulfilled, (state, { payload }) => {
				hanldeCredentials(state, payload);
				handleLoginRules(state, payload);
			})
			.addMatcher(baseAPI.endpoints.verifyByOtp.matchFulfilled, (state, { payload }) => {
				handleVerification(state, payload);
				hanldeCredentials(state, payload);
			})
			.addMatcher(baseAPI.endpoints.changePassword.matchFulfilled, state => {
				removeState(STORAGE_KEY);
				state.isAuthenticated = false;
				state.token = null;
			});
	}
});

export const { logoutReducer } = slice.actions;
export default slice.reducer;

export const selectCredentials = state => state.auth;

function handleVerification(state, credentials) {
	if (!credentials.message) return;
	state.verified = true;
	state.user = credentials.user;
	state.permissions = credentials.permissions;

	saveState(
		{
			...loadState(STORAGE_KEY),
			verified: true,
			user: credentials.user,
			permissions: credentials.permissions,
			currentCompany: credentials.current_company,
			companies: credentials.companies
		},
		STORAGE_KEY
	);
}
function hanldeCredentials(state, credentials) {
	if (!credentials.token) return;
	state.isAuthenticated = true;
	state.verified = false;
	state.token = credentials.token;
	state.companies = credentials.companies;
}

function handleLoginRules(state, payload) {
	saveState(
		{
			...payload,
			loginTime: new Date()
		},
		STORAGE_KEY
	);
}
